module.exports = __webpack_public_path__ + "static/promo-dfe98ae6f662563c88d09fb6a774bd7f.png";